import * as React from 'react';
import * as styles from './label.css';
import { PropsWithChildren } from 'react';
import { UIText3 } from '@cian/ui-kit';

interface ILabel {
  onClick(event: React.MouseEvent<HTMLElement>): void;
}

export const Label = ({ children, onClick }: PropsWithChildren<ILabel>) => {
  return (
    <div onClick={onClick} className={styles['label']}>
      <UIText3>{children}</UIText3>
    </div>
  );
};
